import React, { useEffect, useRef } from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
} from "chart.js";

// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const TerminationsChart = ({ series, categories }) => {
  console.log(series, "series")
  // const filteredSeries = series.filter((s) => s.name === "Resignations");
  const chartContainerRef = useRef(null);
  const chartRef = useRef(null);

  useEffect(() => {
    if (chartContainerRef.current) {
      chartContainerRef.current.scrollLeft = chartContainerRef.current.scrollWidth;
    }
  }, [categories]); // Scrolls to right when categories change

  // Prepare data for Chart.js
  const data = {
    labels: categories,
    datasets: series.map((serie, index) => ({
      label: serie.name,
      data: serie.data,
      borderColor: ["#D3001A", "#FF5733", "#900C3F"][index % 3],
      backgroundColor: ["#D3001A", "#FF5733", "#900C3F"][index % 3],
      tension: 0.4, // for smooth curves
      borderWidth: 3,
      pointRadius: 5,
      pointHoverRadius: 7,
      fill: false,
    })),
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        mode: 'index',
        intersect: false,
        enabled: true,
      },
      datalabels: {
        align: 'top',

        display: (ctx) => ctx.dataset.data[ctx.dataIndex] !== 0,
        color: "#000",
        font: {
          weight: "bold",
          size: 12,
        },
        formatter: (value) => (value === 0 ? "" : value),
      },
    },
    scales: {
      x: {
        ticks: {
          font: {
            size: 12,
          },
          maxRotation: 45,
          minRotation: 45,
        },
      },
      y: {
        title: {
          display: true,
          text: "Number of Employees",
        },
        max: (context) => {
          const allValues = context.chart.data.datasets.flatMap(dataset => dataset.data);
          const maxValue = Math.max(...allValues);
          
          // Find the step size by analyzing the data
          const sortedValues = [...new Set(allValues)].sort((a, b) => a - b);
          let stepSize = 1;
          
          if (sortedValues.length >= 2) {
            // Calculate differences between consecutive values
            const differences = [];
            for (let i = 1; i < sortedValues.length; i++) {
              differences.push(sortedValues[i] - sortedValues[i-1]);
            }
            // Use the most common difference as step size
            stepSize = Math.min(...differences);
          }
          
          // Store the step size in the chart instance for use in ticks
          context.chart.stepSize = stepSize;
          
          // Add two more steps above the maximum
          return maxValue + (stepSize * 2);
        },
        ticks: {
          callback: function(value) {
            // Use the step size stored in the chart instance
            return value % this.chart.stepSize === 0 ? value : '';
          }
        }
      },
    },
  };

  return (
    <div
      ref={chartContainerRef}
      style={{
        marginBottom: "30px",
        overflowX: "auto",
        overflowY: "hidden", 
        whiteSpace: "nowrap",
        maxHeight: "310px", 
      }}
    >
      <div style={{ width: `${categories.length * 50}px`, minWidth: "600px", height: "290px" }}>
        <Line ref={chartRef} data={data} options={options} />
      </div>
    </div>
  );
};

export default TerminationsChart;
